<ng-container *ngIf="show && content$ | async as content; else loading">
  <div class="modal-body help-body">
    <h2
      class="text-primary text-uppercase font-weight-light border-bottom pb-3"
    >
      {{ content.title }}
    </h2>

    <markdown>{{ content.content }}</markdown>
  </div>
</ng-container>

<ng-template #loading>
  <div class="modal-body">
    <p class="my-5 my-5 text-center" *ngIf="show && !noContent">
      <i class="fa fa-spinner-third fa-lg text-primary fa-spin"></i>
    </p>
  </div>
</ng-template>

<div class="modal-body help-body" *ngIf="show && noContent">
  <p class="text-center h3 text-uppercase text-muted">
    {{ 'help-modal.no-content' | translate }} <br />
    <button type="button" class="btn btn-link" (click)="onClose()">
      {{ 'Close' | translate }}
    </button>
  </p>
</div>

<div class="modal-footer text-center py-2" *ngIf="show">
  <button class="btn btn-primary btn-block" (click)="onClose()">
    {{ 'Close' | translate }}
  </button>
</div>
